export const api = {
  get: function (query, header = {}) {
    return new Promise(function (resolve, reject) {
      let opts = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...header,
        },
      };
      fetch(query, opts)
        .then((response) => response.json())
        .then(function (data) {
          resolve(data);
        })
        .catch((error) => {
          let err = {
            resError: error,
            message: "Server not responding!",
          };
          reject(err);
        });
    });
  },
  post: function (url_path, body, header = {}) {
    return new Promise(function (resolve, reject) {
      let opts = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...header,
        },
        body: JSON.stringify(body),
      };
      fetch(url_path, opts)
        .then((response) => response.json())
        .then(function (data) {
          resolve(data);
        })
        .catch((error) => {
          let err = {
            resError: error,
            message: "Server not responding!",
          };
          reject(err);
        });
    });
  },
  delete: function (url_path, body, header = {}) {
    return new Promise(function (resolve, reject) {
      let opts = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          ...header,
        },
        body: JSON.stringify(body),
      };
      fetch(url_path, opts)
        .then((response) => response.json())
        .then(function (data) {
          resolve(data);
        })
        .catch((error) => {
          let err = {
            resError: error,
            message: "Server not responding!",
          };
          reject(err);
        });
    });
  },
};
